import { Component, inject, signal } from "@angular/core";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { ConfirmationService } from "primeng/api";
import { ButtonDirective } from "primeng/button";
import { ConfirmDialog } from "primeng/confirmdialog";
import { TableModule } from "primeng/table";
import { NgxPaginationModule } from "ngx-pagination";
import { TranslatePipe } from "@ngx-translate/core";
import { AbstractListController } from "src/app/common/abstract-list.component";
import { PARAM_LOCATIONS_TYPE_PATH } from "src/app/constants/constants";
import { Locations } from "src/app/models/locations";
import { LocationsService } from "src/app/services/locations.service";
import { DynamicFiltersComponent } from "../../../components/dynamic-filters/dynamic-filters.component";

import { TPipe } from "../../../i18n/t.pipe";
@Component({
  standalone: true,
  selector: "app-manage-locations",
  templateUrl: "./manage-locations.component.html",
  imports: [TPipe, DynamicFiltersComponent, ButtonDirective, RouterLink, TableModule, NgxPaginationModule, ConfirmDialog, TranslatePipe],
})
export class ManageLocationsComponent extends AbstractListController<Locations, any> {
  title = "Comuni / Province";
  readonly cols = signal<any[]>(undefined);

  constructor() {
    const service = inject(LocationsService);
    super(service, inject(ConfirmationService), inject(Router), inject(ActivatedRoute), PARAM_LOCATIONS_TYPE_PATH);

    this.cols.set([
      { field: "name", header: "Nome" },
      { field: "description", header: "Descrizione" },
    ]);
    this.colsFilter.set([
      { field: "name", icon: "pi-tag", header: "Nome", type: "string" },
      { field: "description", icon: "pi-align-left", header: "Descrizione", type: "string" },
    ]);
  }
}
